import { memo } from "react";
import Answer from "./Answer";
import AnswerDateRange from "./AnswerDateRange";
import AnswerDD from "./AnswerDD";
import AnswerRadio from "./AnswerRadio";
import AnswerTracker from "./AnswerTracker";
import { Text, View } from "@react-pdf/renderer";
import { globalStyles } from "config/pdfStyles";

const RenderAnswer = ({ answer, question, containerStyles = globalStyles.reportQuestionOuter, wrapContainer = false, ...props }) => {
  const hideAnswer = answer?.answer?.other_details?.visibility == "hidden";
  return (
    !hideAnswer && (
      <View style={containerStyles} wrap={wrapContainer}>
        {/* {question?.question_type} */}
        {props.showQuestion !== false && (
          <Text style={globalStyles.reportQuestion}>
            {question?.question}
          </Text>
        )}
        {question?.question_type === "textarea_radio" ? (
          <AnswerRadio
            answer={answer}
            question={question}
          />
        ) : question?.question_type === "textarea_dd" ? (
          <AnswerDD
            answer={answer}
            question={question}
          />
        ) : question?.question_type === "date" ? (
          <AnswerDateRange
            answer={answer}
          />
        ) : question?.question_type === "tracker" ? (
          <AnswerTracker
            answer={answer}
            question={question}
          />
        ) : (
          <Answer
            answer={answer}
          />
        )}
      </View>
    )
  );
};

export const RenderAnswerByQId = memo(function ({ questionId, reportQuestions, reportAnswers, ...props }) {
  const question = reportQuestions?.length && reportQuestions?.find((q) => q.id === questionId);
  const answer = reportAnswers?.length && reportAnswers?.find((a) => a.question_id === questionId);
  return (
    <RenderAnswer
      answer={answer}
      question={question}
      {...props}
    />
  )
});

export default RenderAnswer;